import React, { useContext, useState, useEffect, useRef } from 'react';
import { CKEditor } from 'ckeditor4-react';
import { withStyles, makeStyles, useTheme } from '@mui/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { darkenColor } from '../../utils/appHelper';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    dialogHeight: {
        // minHeight: "500px",
        // maxHeight: "500px"
        overflow: 'hidden'
    },
    content: {
        margin: theme.spacing(4),
    }
}));
const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: theme.palette.mode === 'dark' ? darkenColor(theme.palette.background.default, 10) : theme.palette.primary.main,
        color: '#fff'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography className="font500" variant="subtitle1" noWrap>{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        // padding: '25px 16px',
        padding: '0px 0px',
        // width: '500px',
        // [theme.breakpoints.down(281)]: {
        //     width: '218px',
        // },
        // [theme.breakpoints.between(281, 322)]: {
        //     width: '258px',
        // },
        // [theme.breakpoints.between(321, 556)]: {
        //     width: '275px'
        // },
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);
function ViewMemo(props) {
    const classes = useStyles();
    const theme = useTheme();
    const editorRef = useRef(null);

    useEffect(() => {
        if (editorRef.current && props.data && props.data.Content !== undefined) {
            const currentData = editorRef.current.getData();
            if (currentData !== props.data.Content) {
                editorRef.current.setData(props.data.Content);
            }
        }
    }, [props.data && props.data.Content]);

    return (
        <>
            <div>
                <Dialog fullWidth={true} onClose={props.onCloseClick} aria-labelledby="customized-dialog-title"
                    open={props.open}>
                    <DialogTitle id="customized-dialog-title" onClose={props.onCloseClick}>
                        View Memo
                    </DialogTitle>
                    <DialogContent dividers className={classes.dialogHeight}>
                        <Grid container alignItems='center'>
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }} >
                                <div style={{ width: '90%' }}>
                                    <Grid container direction="row" spacing={2} alignItems="center" className={classes.content}>
                                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                            <Typography variant="subtitle1" noWrap>{props.data.Title}</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                            <CKEditor
                                                key={theme.palette.mode} // forces re-mount when light/dark mode changes
                                                config={{
                                                    toolbar: [],
                                                    removePlugins: "elementspath,resize",
                                                    allowedContent: 'p h1 h2 strong em s blockquote; a[!href]; img[!src,width,height];',
                                                    contentsCss: `body { background-color: ${theme.palette.background.paper}; color: ${theme.palette.text.primary}; }`,
                                                    on: {
                                                        instanceReady: function () {
                                                            editorRef.current = this;
                                                            const toolbar = this.container.$.querySelector('.cke_top');
                                                            if (toolbar) {
                                                                toolbar.style.backgroundColor = darkenColor(theme.palette.background.default, 5);
                                                                toolbar.style.color = theme.palette.text.primary;
                                                            }
                                                            // Set data after editor is ready in case props.data.Content arrived before instanceReady
                                                            if (props.data && props.data.Content) {
                                                                this.setData(props.data.Content);
                                                            }
                                                        }
                                                    }
                                                }}
                                                data={props.data.Content}
                                                readOnly={true}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        {/* <Button color="primary" variant='contained' onClick={props.onCloseClick}>Close</Button> */}
                    </DialogActions>
                </Dialog>
            </div>
        </>
    )
}

export default ViewMemo;
